module.exports = __webpack_public_path__ + "img/deals-banner.9a70505c.png";